<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Card Title</label>
            <input type="checkbox" v-model="fields.cardTitle.show" />
          </div>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center">
            <label class="label-input mb-0">Badge Items</label>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.items" :key="`rivoneed-badge-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <UploadImage
                    @callback="obj => handleUploadItemIcon(obj, index)"
                    :image="{ imageSrc: item.icon || '' }"
                    :height="`120`"
                    :typeUpload="'image'"
                    @callbackDelete="() => handleRemoveItemIcon(index)"
                  />
                  <v-text-field v-model="item.alt" class="mt-3" label="Icon alt" hide-details />
                  <div class="mt-4">
                    <label class="mb-2 d-block">Content</label>
                    <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

const defaultIcon = 'https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fb04bed73b6428256aeef.png';

export default {
  name: 'card-badge-rivoneed-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Card Badge Rivoneed Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#1a1a1a',
          textColor: '#ffffff',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        cardTitle: {
          show: true,
          content:
            '<h2 style="text-align: center">Risk-Free Purchase, Peace of Mind</h2><p style="text-align: center">30-Day Money-Back Guarantee</p>',
        },
        items: [],
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        cardTitle: { ...this.fields.cardTitle, ...(extract.cardTitle || {}) },
        items: Array.isArray(extract.items) ? extract.items : this.fields.items,
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardBadgeRivoneed(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.items.push({
        icon: defaultIcon,
        alt: '',
        content:
          '<h3>30-Day Money-Back Guarantee</h3><p>Should we not meet your expectations, we offer a full refund within 30 days.</p>',
      });
    },
    handleRemoveItem(index) {
      this.fields.items.splice(index, 1);
    },
    handleUploadItemIcon(obj, index) {
      if (!this.fields.items[index]) return;
      this.$set(this.fields.items[index], 'icon', obj.imageSrc || '');
    },
    handleRemoveItemIcon(index) {
      if (!this.fields.items[index]) return;
      this.$set(this.fields.items[index], 'icon', '');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
